import React, { useState } from 'react'
import styles from './index.module.scss'
import cn from 'classnames'
import DatePicker from 'react-datepicker'
import PropTypes from 'prop-types'
import { pastYears } from '../../../utilities/randomUtilities'
import dayjs from 'dayjs'
import UnderlineSelect from '../../underline-select'

function ReportsFilterForm ({ handleInputChange, initialValues, clearSearch, options, showOptions }) {
  const [formValues, setFormValues] = useState(initialValues)

  const yearToDateOption = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ]

  const statusOptions = [
    { value: 'open', label: 'Open' },
    { value: 'en_route', label: 'En Route' },
    { value: 'completed', label: 'Completed' }
  ]

  function formatDate (date) {
    const dateSplit = (date).split('-')
    const dateYear = parseInt(dateSplit[0])
    const dateMonth = parseInt(dateSplit[1] - 1)
    const dateDay = parseInt(dateSplit[2])
    return new Date(dateYear, dateMonth, dateDay).toUTCString()
  }

  const handleInputChangeWrapper = (newValues) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      ...newValues
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleInputChange(formValues)
  }

  const handleClear = () => {
    let tempVals = {}
    Object.entries(initialValues || {}).forEach(([key, value]) => {
      tempVals = {
        ...tempVals,
        [key]: (Array.isArray(value) ? [] : undefined)
      }
    })
    setFormValues(tempVals)
    clearSearch()
  }

  return (
    <div className={styles.searchContainer}>
      <div className={styles.panel}>
        <form className={styles.form}>
          <div className={styles.inputs}>
            {
              showOptions?.includes('years') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='Years'>
                    <div>Years</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      isDisabled={formValues?.startDate?.length > 0 || formValues?.endDate?.length > 0}
                      options={pastYears(3)}
                      defaultValue={formValues?.years ? formValues?.years?.map(id => pastYears(3).find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        handleInputChangeWrapper({ years: selectedValues })
                      }}
                    />
                  </label>
                </div>
              )
            }
            {
              showOptions?.includes('dateRange') && (
                <>
                  <label className={cn(styles.label, 'control-label', styles.inputFixed)} htmlFor='createdFrom'>
                    Start Date
                    <DatePicker
                      name='startDate'
                      disabled={formValues?.years?.length > 0 || formValues?.yearToDate || formValues?.yearToDate === false}
                      dateFormat='MM/dd/yyyy'
                      selected={formValues?.startDate ? new Date(formatDate(formValues.startDate)) : undefined}
                      maxDate={formValues?.endDate ? new Date(formatDate(formValues.endDate)) : undefined}
                      onChange={(date) => {
                        if (date) {
                          handleInputChangeWrapper({
                            startDate: dayjs(date).format('YYYY-MM-DD')
                          })
                        }
                      }}
                    />
                  </label>
                  <label className={cn(styles.label, 'control-label', styles.inputFixed)} htmlFor='createdTo'>
                    End Date
                    <DatePicker
                      name='endDate'
                      disabled={formValues?.years?.length > 0 || formValues?.yearToDate || formValues?.yearToDate === false}
                      dateFormat='MM/dd/yyyy'
                      selected={formValues?.endDate ? new Date(formatDate(formValues.endDate)) : undefined}
                      minDate={formValues?.startDate ? new Date(formatDate(formValues.startDate)) : undefined}
                      onChange={(date) => {
                        if (date) {
                          handleInputChangeWrapper({
                            endDate: dayjs(date).format('YYYY-MM-DD')
                          })
                        }
                      }}
                    />
                  </label>
                </>
              )
            }
            {
              showOptions?.includes('resourceTypes') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='assetTypes'>
                    <div>Asset Type</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      isSearchable
                      enableSelectAll
                      options={options?.resourceTypes}
                      defaultValue={formValues?.resourceTypes ? formValues?.resourceTypes?.map(id => options?.resourceTypes.find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        handleInputChangeWrapper({ resourceTypes: selectedValues })
                      }}
                    />
                  </label>
                </div>
              )
            }
            {
              showOptions?.includes('ticketTypes') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='ticketTypes'>
                    <div>Ticket Type</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      enableSelectAll
                      isSearchable
                      options={options?.ticketTypes}
                      defaultValue={formValues?.ticketTypes ? formValues?.ticketTypes?.map(id => options?.ticketTypes.find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        handleInputChangeWrapper({ ticketTypes: selectedValues })
                      }}
                    />
                  </label>
                </div>
              )
            }
            {
              showOptions?.includes('status') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='status'>
                    <div>Status</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      enableSelectAll
                      options={statusOptions}
                      defaultValue={formValues?.status ? formValues?.status?.map(id => statusOptions.find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        handleInputChangeWrapper({ status: selectedValues })
                      }}
                    />
                  </label>
                </div>
              )
            }
            {
              showOptions?.includes('drivers') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='driver'>
                    <div>Driver</div>
                    <UnderlineSelect
                      placeholder={''}
                      isMulti
                      enableSelectAll
                      options={options?.drivers}
                      defaultValue={formValues?.drivers ? formValues?.drivers?.map(id => options?.drivers.find(opt => opt.value === id)).filter(Boolean) : []}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions?.map(option => option.value) || []
                        handleInputChangeWrapper({ drivers: selectedValues })
                      }}
                    />
                  </label>
                </div>
              )
            }
            {
              showOptions?.includes('yearToDate') && (
                <div>
                  <label className={cn(styles.label, styles.border)} htmlFor='yearToDate'>
                    <div>Year-To-Date</div>
                    <UnderlineSelect
                      placeholder={''}
                      isDisabled={formValues?.startDate?.length > 0 || formValues?.endDate?.length > 0}
                      options={yearToDateOption}
                      defaultValue={(formValues?.yearToDate === null || formValues?.yearToDate === undefined) ? '' : yearToDateOption.find(opt => opt.value === formValues?.yearToDate)}
                      onChange={(selectedOption) => {
                        handleInputChangeWrapper({ yearToDate: selectedOption?.value })
                      }}
                    />
                  </label>
                </div>
              )
            }
          </div>
          <div className={styles.btns}>
            <div>
              <button
                type='submit'
                onClick={handleSubmit}
                className='dis-btn dis-btn-sm dis-btn-success'>
                Search
                <i className='material-icons dis-btn-icon'>search</i>
              </button>
              <button
                type='button'
                onClick={handleClear}
                className={cn(styles.clearBtn, 'dis-btn dis-btn-white dis-btn-sm')}>
                Clear
                <i className='material-icons dis-btn-icon'>clear</i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

ReportsFilterForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  initialValues: PropTypes.any,
  clearSearch: PropTypes.func,
  showOptions: PropTypes.arrayOf(PropTypes.oneOf(['dateRange', 'years', 'ticketTypes', 'resourceTypes', 'status', 'drivers', 'yearToDate'])),
  options: PropTypes.shape({
    ticketTypes: PropTypes.array,
    resourceTypes: PropTypes.array,
    drivers: PropTypes.array
  })
}
export default ReportsFilterForm
